
export const state = {
    userprofile:[],
    usersrole: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/userprofile/state.js